
export enum UnitOccupation {
    None = 0,
    ArchitectOrEngineer = 1,
    BusinessAnalystAccountantOrFinancialAdvisor = 2,
    CommunityAndSocialServicesWorker = 3,
    ConstructionMechanicOrMaintenanceWorker = 4,
    Doctor = 5,
    Educator = 6,
    EntertainmentSportsArtsOrMedia = 7,
    ExecutiveOrManager = 8,
    FarmerFishermanForester = 9,
    FoodServiceWorker = 10,
    GigWorker = 11,
    HospitalityOfficeOrAdministrativeSupportWorker = 12,
    HouseholdManager = 13,
    JanitorHousekeeperLandscaper = 14,
    Lawyer = 15,
    ManufacturingOrProductionWorker = 16,
    MilitaryOrPublicSafety = 17,
    NurseHealthcareTechnicianOrHealthcareSupport = 18,
    PersonalCareOrServiceWorker = 19,
    PilotDriverOperator = 20,
    SalesRepresentativeBrokerAgent = 21,
    ScientistOrTechnologist = 22,
    Student = 23
}

export namespace UnitOccupation {
    export function toString(unitOccupation: UnitOccupation): string {
        switch (unitOccupation) {
            case UnitOccupation.ArchitectOrEngineer:
                return 'Architect Or Engineer';
            case UnitOccupation.BusinessAnalystAccountantOrFinancialAdvisor:
                return 'Business Analyst Accountant Or Financial Advisor';
            case UnitOccupation.CommunityAndSocialServicesWorker:
                return 'Community And Social Services Worker';
            case UnitOccupation.ConstructionMechanicOrMaintenanceWorker:
                return 'Construction Mechanic Or Maintenance Worker';
            case UnitOccupation.Doctor:
                return 'Doctor';
            case UnitOccupation.Educator:
                return 'Educator';
            case UnitOccupation.EntertainmentSportsArtsOrMedia:
                return 'Entertainment Sports Arts Or Media';
            case UnitOccupation.ExecutiveOrManager:
                return 'Executive Or Manager';
            case UnitOccupation.FarmerFishermanForester:
                return 'Farmer Fisherman Forester';
            case UnitOccupation.FoodServiceWorker:
                return 'Food Service Worker';
            case UnitOccupation.GigWorker:
                return 'Gig Worker';
            case UnitOccupation.HospitalityOfficeOrAdministrativeSupportWorker:
                return 'Hospitality Office Or Administrative Support Worker';
            case UnitOccupation.HouseholdManager:
                return 'Household Manager';
            case UnitOccupation.JanitorHousekeeperLandscaper:
                return 'Janitor Housekeeper Landscaper';
            case UnitOccupation.Lawyer:
                return 'Lawyer';
            case UnitOccupation.ManufacturingOrProductionWorker:
                return 'Manufacturing Or Production Worker';
            case UnitOccupation.MilitaryOrPublicSafety:
                return 'Military Or Public Safety';
            case UnitOccupation.NurseHealthcareTechnicianOrHealthcareSupport:
                return 'Nurse Healthcare Technician Or Healthcare Support';
            case UnitOccupation.PersonalCareOrServiceWorker:
                return 'Personal Care Or Service Worker';
            case UnitOccupation.PilotDriverOperator:
                return 'Pilot Driver Operator';
            case UnitOccupation.SalesRepresentativeBrokerAgent:
                return 'Sales Representative Broker Agent';
            case UnitOccupation.ScientistOrTechnologist:
                return 'Scientist Or Technologist';
            case UnitOccupation.Student:
                return 'Student';
            default:
                return '';
        }
    }

    export function listAll(): UnitOccupation[] {
        return [
            UnitOccupation.ArchitectOrEngineer,
            UnitOccupation.BusinessAnalystAccountantOrFinancialAdvisor,
            UnitOccupation.CommunityAndSocialServicesWorker,
            UnitOccupation.ConstructionMechanicOrMaintenanceWorker,
            UnitOccupation.Doctor,
            UnitOccupation.Educator,
            UnitOccupation.EntertainmentSportsArtsOrMedia,
            UnitOccupation.ExecutiveOrManager,
            UnitOccupation.FarmerFishermanForester,
            UnitOccupation.FoodServiceWorker,
            UnitOccupation.GigWorker,
            UnitOccupation.HospitalityOfficeOrAdministrativeSupportWorker,
            UnitOccupation.HouseholdManager,
            UnitOccupation.JanitorHousekeeperLandscaper,
            UnitOccupation.Lawyer,
            UnitOccupation.ManufacturingOrProductionWorker,
            UnitOccupation.MilitaryOrPublicSafety,
            UnitOccupation.NurseHealthcareTechnicianOrHealthcareSupport,
            UnitOccupation.PersonalCareOrServiceWorker,
            UnitOccupation.PilotDriverOperator,
            UnitOccupation.SalesRepresentativeBrokerAgent,
            UnitOccupation.ScientistOrTechnologist,
            UnitOccupation.Student
        ];
    }

    export function parse(str: string): UnitOccupation {
        return UnitOccupation[str];
    }
}